export const camelToDashed = (camel: string) =>
  camel && camel.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);

export const capitalizeFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);
